import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import cn from "classnames";
import style from "../common.module.scss";
import { Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import OrderBookingCard from "../../../../pages/orders/booking/OrderBookingCard";
import CustomInput from "../../../custom/custom-input/CustomInput";

const AssignExecutor = ({ user, orderId, item, onUpdateData, fetchOrderData }) => {
  const { t } = useTranslation();
  const [isBooked, setBookedState] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [getOrder, setOrder] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isAirTransport, setAirTransport] = useState(false);
  const [trackingLinks, setTrackingLinks] = useState({});
  const [errorTexts, setErrorTexts] = useState({});
  const [isLoadingLink, setLoadingLink] = useState(false);
  const [isLoadingСonfirm, setLoadingСonfirm] = useState(false);

  const handleTrackingLinkChange = (orderId, value) => {
    setTrackingLinks((prev) => ({ ...prev, [orderId]: value }));
    setErrorTexts((prev) => ({ ...prev, [orderId]: "" }));
  };

  const fetchOrderDataById = async () => {
    setLoading(true);
    try {
      const { data } = await Order.getOrderForExpeditor({ orderId });
      setBookedState(data.isBooked);
      setOrder(data.order);
      if (data.vehicle && data.driver) {
        getBookData({
          driver: data.driver,
          transport: data.vehicle,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const sendTrackingLink = async (orderId) => {
    const link = trackingLinks[orderId]?.trim();
    if (!link) {
      setErrorTexts((prev) => ({
        ...prev,
        [orderId]: t('assignExecutor.validation.trackingLinkRequired'),
      }));
      return;
    }

    setLoadingLink(true);
    try {
      const data = {
        transportationType: "airtransport",
        trackingLink: link,
      };
      await Order.bookAirTransportOrder(orderId, data);
      toast.success(t('assignExecutor.toast.trackingLinkSuccess'));
      setTrackingLinks((prev) => ({ ...prev, [orderId]: "" }));
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      console.log(e);
      toast.error(t('assignExecutor.toast.trackingLinkError'));
    } finally {
      setLoadingLink(false);
    }
  };

  const getBookData = ({ driver, transport }) => {
    setDrivers([
      // ...drivers, // TODO вернуть, когда доделаем бронирование одинаковых заказов
      {
        ...driver,
        vehicle: transport,
      },
    ]);
  };

  const sendOrderBooking = async () => {
    try {
      const driver = drivers[0] || {};
      const body = {
        driverId: driver.id,
        vehicleId: driver.vehicle?.id,
      };
      setLoadingСonfirm(true);

      await Order.sendOrderBookPub(getOrder.id, body);
      setIsOpenModal(false);
      setLoadingСonfirm(false);
      toast.success(t('assignExecutor.toast.driverAssignedSuccess'));
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      setLoadingСonfirm(false);
      toast.error(t('assignExecutor.toast.genericError'));
      console.log("Ошибка при назначение водителя", e); // Keep console log in original language
    }
  };

  const onDeleteDriver = (driver) => {
    if (isBooked) {
      // onCancelBooking()
    } else {
      setDrivers(drivers.filter((d) => d.id !== driver.id));
    }
  };

  useEffect(() => {
    fetchOrderDataById();
  }, [orderId]);

  return (
    <div className={cn(style.cargo_wrapper)}>
      <div className={cn(style.cargo_title, style.orders_title)}>{t('assignExecutor.title')}</div>
      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <CustomButton
          text={t('assignExecutor.buttons.assignExecutor')}
          style={{ flex: "1" }}
          onClick={() => {
            setIsOpenModal(true);
            setAirTransport(false);
            setTrackingLinks((prev) => ({ ...prev, [orderId]: "" }));
            setErrorTexts((prev) => ({ ...prev, [orderId]: "" }));
          }}
          isLoading={isLoading}
        />
        {/* <CustomButton
          text="Авиаперевозка"
          style={{ flex: "1" }}
          onClick={() => setAirTransport(true)}
          isLoading={isLoading}
        /> */}
      </div>
      {isAirTransport && (
        <div style={{ display: "flex", gap: "16px", width: "100%" }}>
          <CustomInput
            value={trackingLinks[orderId] || ""}
            isDeleteText
            isBgGray
            inputType="text"
            labelText={t('assignExecutor.trackingLink.label')}
            placeholder={t('assignExecutor.trackingLink.placeholder')}
            onChangeValue={(value) => handleTrackingLinkChange(orderId, value)}
            errorText={errorTexts[orderId]}
            style={{ flex: "2" }}
          />
          <CustomButton
            text={t('assignExecutor.buttons.send')}
            style={{ flex: "1" }}
            onClick={() => sendTrackingLink(orderId)}
            isLoading={isLoadingLink}
          />
        </div>
      )}

      {isOpenModal && (
        <div className={cn("modal-overlay", style.modal)}>
          <div className={style.modal_content}>
            <OrderBookingCard
              driver={drivers[0]}
              companyId={user?.companyId}
              orderId={orderId}
              onDelete={onDeleteDriver}
              isBooked={isBooked}
              getDataSubmit={getBookData}
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              onSubmitBooking={sendOrderBooking}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignExecutor;
